/**
 * 증빙서류 이미지 마스킹 편집기
 * (imgMaskEditor.jsp / #popup-masking-1)
 *
 * - 드래그로 마스킹 영역 추가
 * - 선택 영역 이동 / 모서리·변 핸들로 확대·축소
 * - 선택 영역 옆 휴지통 / Delete·Backspace로 삭제
 * - PC: Space+드래그로 이미지 이동
 * - 모바일: 두 손가락 이동·핀치 확대/축소
 *
 * 사용 예:
 *   imgMaskEditor.open({
 *     file: file,              // File 객체 (또는 url)
 *     opener: $btn,
 *     onAttach: function (maskedFile) { ... },
 *     onCancel: function () { ... }
 *   });
 */
(function () {

    var HANDLES = ['nw', 'n', 'ne', 'e', 'se', 's', 'sw', 'w'];
    var MAX_FILE_SIZE = 10 * 1024 * 1024;
    var ALLOWED_EXT = /^(jpe?g|png)$/i;
    var MIN_SCALE = 0.5;
    var MAX_SCALE = 4;

    var imgMaskEditor = {
        init: function () {
            var self = this;

            self.setting();
            if (!self.$popup.length || !self.$stage.length) {
                return;
            }

            self.bindEvents();
            self.bindLayoutEvents();
            self.ready = true;
        },

        setting: function () {
            var self = this;

            self.$popup = $('#popup-masking-1');
            self.$stage = self.$popup.find('.masking-area');
            self.$noti = self.$popup.find('.noti-popup');
            self.$undoBtn = self.$popup.find('#undoBtn');
            self.$attachBtn = self.$popup.find('#attachBtn');
            self.$check1 = $('#popup-mask-check1');
            self.$check3 = $('#popup-mask-check3');
            self.$check4 = $('#popup-mask-check4');
            self.$check5 = $('#popup-mask-check5');

            self.canvas = null;
            self.ctx = null;
            self.committed = null;
            self.cctx = null;
            self.origImg = null;
            self.curName = 'image.png';
            self.mode = 'box';
            self.regions = [];
            self.selectedIndex = -1;
            self.interaction = null;
            self.undoStack = [];
            self.scale = 1;
            self.baseFit = 1;
            self.offsetX = 0;
            self.offsetY = 0;
            self.pinch = null;
            self.spacePressed = false;
            self.forceClose = false;
            self.dirty = false;
            self.onAttach = null;
            self.onCancel = null;
            self.opener = null;
            self.ready = false;
            self.bound = false;
            self._layoutBound = false;
        },

        /**
         * 파일/URL로 마스킹 팝업 오픈
         * @param {Object} opts
         * @param {File} [opts.file]
         * @param {string} [opts.url]
         * @param {string} [opts.name]
         * @param {jQuery|Element} [opts.opener]
         * @param {Function} [opts.onAttach] - masked File 전달
         * @param {Function} [opts.onCancel]
         */
        open: function (opts) {
            var self = this;
            opts = opts || {};

            if (!self.ready) {
                self.init();
            }
            if (!self.$popup.length) return;

            self.onAttach = typeof opts.onAttach === 'function' ? opts.onAttach : null;
            self.onCancel = typeof opts.onCancel === 'function' ? opts.onCancel : null;
            self.opener = opts.opener || null;
            self.forceClose = false;
            self.dirty = false;

            if (opts.file) {
                if (!self.validateFile(opts.file)) {
                    self.openCheck(self.$check1);
                    return;
                }
                self.curName = opts.name || opts.file.name || 'image.png';
                self.readFile(opts.file);
            } else if (opts.url) {
                self.curName = opts.name || 'image.png';
                self.loadImageFromUrl(opts.url);
            } else {
                self.openCheck(self.$check3);
                return;
            }

            self.$noti.show();
            self.setUndoEnabled(false);
            self.setAttachEnabled(false);

            if (self.$popup.vcModal) {
                self.openModal(self.$popup, { opener: self.opener });
            }
        },

        /**
         * 이미 딤이 있으면 추가 딤을 만들지 않음 (인증 팝업 위 마스킹 등 중첩 시 이중 딤 방지)
         * @param {jQuery} $popup
         * @param {Object} [opts]
         * @param {boolean} [opts.forceDim=false] true면 기존 딤이 있어도 딤 유지(얼럿용)
         */
        openModal: function ($popup, opts) {
            var self = this;
            if (!$popup || !$popup.length || !$popup.vcModal) return;

            opts = opts || {};
            var forceDim = !!opts.forceDim;
            var modalOpts = $.extend({}, opts);
            delete modalOpts.forceDim;

            var existingDimCount = $('.ui_modal_dim').length;

            $popup.off('modalshow.imgMaskDim').one('modalshow.imgMaskDim', function () {
                // ModalManager가 dim을 붙인 뒤에 처리
                setTimeout(function () {
                    if (!forceDim && existingDimCount > 0) {
                        $popup.siblings('.ui_modal_dim').remove();
                    }
                }, 0);
            });

            $popup.vcModal(modalOpts).vcModal('open');
        },

        validateFile: function (file) {
            if (!file) return false;
            if (file.size > MAX_FILE_SIZE) return false;
            var name = file.name || '';
            var ext = name.indexOf('.') > -1 ? name.split('.').pop() : '';
            var typeOk = file.type === 'image/jpeg' || file.type === 'image/png';
            var extOk = ALLOWED_EXT.test(ext);
            return typeOk || extOk;
        },

        readFile: function (file) {
            var self = this;
            var rd = new FileReader();
            rd.onload = function () {
                self.loadImage(rd.result);
            };
            rd.onerror = function () {
                self.openCheck(self.$check3);
            };
            rd.readAsDataURL(file);
        },

        loadImageFromUrl: function (url) {
            var self = this;
            var img = new Image();
            img.crossOrigin = 'anonymous';
            img.onload = function () {
                self.setupCanvas(img);
            };
            img.onerror = function () {
                self.openCheck(self.$check3);
            };
            img.src = url;
        },

        loadImage: function (dataUrl) {
            var self = this;
            var img = new Image();
            img.onload = function () {
                self.setupCanvas(img);
            };
            img.onerror = function () {
                self.openCheck(self.$check3);
            };
            img.src = dataUrl;
        },

        setupCanvas: function (img) {
            var self = this;
            self.origImg = img;
            self.regions = [];
            self.selectedIndex = -1;
            self.interaction = null;
            self.undoStack = [];
            self.dirty = false;
            self.scale = 1;
            self.baseFit = 1;
            self.offsetX = 0;
            self.offsetY = 0;

            self.$stage.empty();

            self.$viewport = $('<div class="masking-viewport"></div>');
            self.$viewport.css({
                position: 'relative',
                width: '100%',
                height: '100%',
                overflow: 'hidden',
                touchAction: 'none',
                userSelect: 'none'
            });

            self.canvas = document.createElement('canvas');
            self.canvas.width = img.naturalWidth;
            self.canvas.height = img.naturalHeight;
            self.canvas.style.display = 'block';
            self.canvas.style.transformOrigin = '0 0';
            self.ctx = self.canvas.getContext('2d');

            // 선택 핸들/휴지통은 줌되지 않는 HTML 오버레이로 렌더 (선명도 유지)
            self.$uiLayer = $('<div class="masking-ui-layer"></div>');
            self.$uiLayer.css({
                position: 'absolute',
                left: 0,
                top: 0,
                right: 0,
                bottom: 0,
                overflow: 'hidden',
                pointerEvents: 'none',
                zIndex: 2
            });

            self.$viewport[0].appendChild(self.canvas);
            self.$viewport[0].appendChild(self.$uiLayer[0]);
            self.$stage[0].appendChild(self.$viewport[0]);

            self.committed = document.createElement('canvas');
            self.committed.width = img.naturalWidth;
            self.committed.height = img.naturalHeight;
            self.cctx = self.committed.getContext('2d');

            self.rebuildCommitted();
            self.render();
            self.bindPointer();
            self.bindLayoutEvents();
            self.fitToStage();
            // 모달 오픈 직후 레이아웃 반영을 위해 한 번 더 맞춤
            setTimeout(function () { self.fitToStage(); }, 50);
            setTimeout(function () { self.fitToStage(); }, 250);
            self.setUndoEnabled(false);
            self.setAttachEnabled(true);
            self.setCursor('crosshair');
        },

        /**
         * 마스킹 영역을 팝업/디바이스 가용 높이에 맞게 확장 (iOS 하단 여백 축소)
         */
        layoutStage: function () {
            var self = this;
            if (!self.$popup || !self.$popup.length || !self.$stage || !self.$stage.length) return;

            var vv = window.visualViewport;
            var viewH = (vv && vv.height) ? vv.height : (window.innerHeight || document.documentElement.clientHeight || 0);
            if (!viewH) return;

            var $header = self.$popup.find('.pop-header');
            var $footer = self.$popup.find('.pop-footer');
            var $bullet = self.$popup.find('.bullet-gray-box');
            var $conts = self.$popup.find('.pop-conts');

            var chrome = 0;
            chrome += $header.outerHeight(true) || 0;
            chrome += $footer.outerHeight(true) || 0;
            chrome += $bullet.outerHeight(true) || 0;
            if ($conts.length) {
                chrome += (parseFloat($conts.css('padding-top')) || 0);
                chrome += (parseFloat($conts.css('padding-bottom')) || 0);
            }

            // 모바일 풀스크린 팝업 기준: visualViewport 높이에서 크롬을 뺀 영역을 스테이지로 사용
            var isMobile = window.matchMedia && window.matchMedia('(max-width: 1024px)').matches;
            var stageH;
            if (isMobile) {
                stageH = Math.floor(viewH - chrome);
            } else {
                var popupH = self.$popup.outerHeight() || viewH;
                stageH = Math.floor(Math.min(popupH, viewH) - chrome);
            }

            if (stageH < 180) stageH = 180;

            self.$stage.css({
                width: '100%',
                height: stageH + 'px',
                minHeight: stageH + 'px',
                maxHeight: stageH + 'px',
                boxSizing: 'border-box'
            });

            if (self.$viewport && self.$viewport.length) {
                self.$viewport.css({
                    width: '100%',
                    height: '100%'
                });
            }
        },

        /**
         * 스테이지를 가득 채우도록 이미지 확대/축소 (cover)
         * - 배경 여백 최소화, 넘치는 부분은 팬으로 이동
         */
        fitToStage: function () {
            var self = this;
            if (!self.canvas || !self.$stage || !self.$stage.length) return;

            self.layoutStage();

            var stageW = self.$stage.width();
            var stageH = self.$stage.height();
            if (!stageW || !stageH) return;

            var fitW = stageW / self.canvas.width;
            var fitH = stageH / self.canvas.height;
            // cover: 가로/세로 중 더 크게 확대해 스테이지를 채움 (여백 최소화)
            var fit = Math.max(fitW, fitH);
            if (!isFinite(fit) || fit <= 0) fit = 1;

            var displayW = self.canvas.width * fit;
            var displayH = self.canvas.height * fit;

            self.baseFit = fit;
            self.canvas.style.maxWidth = 'none';
            self.canvas.style.width = displayW + 'px';
            self.canvas.style.height = displayH + 'px';
            self.scale = 1;
            // 가로는 중앙, 세로는 상단 맞춤 (넘치는 부분은 팬으로 이동)
            self.offsetX = (stageW - displayW) / 2;
            self.offsetY = 0;
            self.applyViewTransform();
            self.render();
        },

        bindLayoutEvents: function () {
            var self = this;
            if (self._layoutBound) return;
            self._layoutBound = true;

            var onResize = function () {
                if (!self.canvas || !self.$popup || !self.$popup.is(':visible')) return;
                self.fitToStage();
            };

            $(window).on('resize.imgMaskLayout orientationchange.imgMaskLayout', onResize);
            if (window.visualViewport) {
                window.visualViewport.addEventListener('resize', onResize);
                window.visualViewport.addEventListener('scroll', onResize);
            }

            // 팝업 오픈 후 레이아웃이 잡히면 한 번 더
            self.$popup.on('modalshow.imgMaskLayout', function () {
                setTimeout(onResize, 50);
                setTimeout(onResize, 250);
            });
        },

        bindEvents: function () {
            var self = this;
            if (self.bound) return;
            self.bound = true;

            self.$undoBtn.on('click', function () {
                self.undo();
            });

            self.$attachBtn.on('click', function () {
                self.attach();
            });

            // 안내 배너: X 버튼 또는 팝업 내 noti 바깥 영역 클릭 시 닫기
            self.$popup.on('click.imgMaskNoti', function (e) {
                if (!self.$noti.length || !self.$noti.is(':visible')) return;

                var $t = $(e.target);
                if ($t.closest('.noti-popup').length) {
                    // noti 안에서는 X(btn-close)만 닫기
                    if (!$t.closest('.btn-close').length) return;
                }
                self.hideNoti();
            });

            // 팝업 닫기(편집 중이면 확인)
            self.$popup.on('click', '.ui_modal_close', function (e) {
                if (self.forceClose) return;
                if (!self.isDirty()) return;
                e.preventDefault();
                e.stopImmediatePropagation();
                self.openCheck(self.$check4);
                return false;
            });

            self.$check4.find('[data-role=ok]').on('click', function () {
                self.forceClose = true;
                if (self.$check4.vcModal) self.$check4.vcModal('hide');
                if (self.$popup.vcModal) self.$popup.vcModal('hide');
                self.resetEditor();
                if (self.onCancel) self.onCancel();
                self.forceClose = false;
            });

            $(document).on('keydown.imgMaskEditor', function (e) {
                if (!self.canvas) return;
                if (!self.$popup.is(':visible')) return;
                var tag = (e.target && e.target.tagName || '').toLowerCase();
                if (tag === 'input' || tag === 'textarea') return;

                if (e.code === 'Space' || e.key === ' ') {
                    e.preventDefault();
                    if (!self.spacePressed) {
                        self.spacePressed = true;
                        if (!self.interaction) self.setCursor('grab');
                    }
                    return;
                }

                if ((e.key === 'Delete' || e.key === 'Backspace') && self.selectedIndex >= 0) {
                    e.preventDefault();
                    self.deleteSelectedRegion();
                }
            });

            $(document).on('keyup.imgMaskEditor', function (e) {
                if (e.code === 'Space' || e.key === ' ') {
                    self.spacePressed = false;
                    if (!self.interaction) {
                        self.setCursor(self.selectedIndex >= 0 ? 'move' : 'crosshair');
                    }
                }
            });
        },

        openCheck: function ($popup) {
            if (!$popup || !$popup.length) return;
            // 마스킹 위 얼럿은 딤 유지 (본 팝업과 구분)
            this.openModal($popup, {
                opener: this.opener || this.$attachBtn,
                forceDim: true
            });
        },

        hideNoti: function () {
            if (this.$noti && this.$noti.length && this.$noti.is(':visible')) {
                this.$noti.hide();
            }
        },

        isDirty: function () {
            return this.dirty || this.regions.length > 0;
        },

        setUndoEnabled: function (enabled) {
            var self = this;
            self.$undoBtn.prop('disabled', !enabled);
            if (enabled) {
                self.$undoBtn.removeClass('dark-gray').addClass('white');
            } else {
                self.$undoBtn.addClass('dark-gray');
            }
        },

        setAttachEnabled: function (enabled) {
            var self = this;
            self.$attachBtn.prop('disabled', !enabled);
            if (enabled) {
                self.$attachBtn.removeClass('dark-gray').addClass('pink');
            } else {
                self.$attachBtn.removeClass('pink').addClass('dark-gray');
            }
        },

        deleteSelectedRegion: function () {
            var self = this;
            if (self.selectedIndex < 0 || !self.regions[self.selectedIndex]) return;
            self.pushUndo();
            self.regions.splice(self.selectedIndex, 1);
            self.selectedIndex = -1;
            self.interaction = null;
            self.dirty = true;
            self.rebuildCommitted();
            self.render();
            self.setCursor('crosshair');
        },

        resetEditor: function () {
            var self = this;
            self.regions = [];
            self.selectedIndex = -1;
            self.interaction = null;
            self.undoStack = [];
            self.dirty = false;
            self.origImg = null;
            self.canvas = null;
            self.ctx = null;
            self.committed = null;
            self.cctx = null;
            self.scale = 1;
            self.baseFit = 1;
            self.offsetX = 0;
            self.offsetY = 0;
            self.$stage.empty();
            self.setUndoEnabled(false);
            self.setAttachEnabled(false);
        },

        rebuildCommitted: function () {
            var self = this;
            if (!self.origImg || !self.cctx) return;
            self.cctx.clearRect(0, 0, self.committed.width, self.committed.height);
            self.cctx.drawImage(self.origImg, 0, 0);
            for (var i = 0; i < self.regions.length; i++) {
                self.applyMask(self.regions[i]);
            }
        },

        render: function (previewRect) {
            var self = this;
            if (!self.ctx || !self.committed) return;

            // 이미지+마스킹만 캔버스에 그림 (선택 UI는 오버레이)
            self.ctx.clearRect(0, 0, self.canvas.width, self.canvas.height);
            self.ctx.drawImage(self.committed, 0, 0);
            self.updateUiOverlay(previewRect || null);
        },

        /**
         * 캔버스 자연좌표 → 뷰포트(오버레이) CSS 좌표
         */
        toViewPos: function (nx, ny) {
            var vs = this.getViewScale();
            return {
                x: this.offsetX + nx * vs,
                y: this.offsetY + ny * vs
            };
        },

        /**
         * 선택 핸들/가이드/휴지통 HTML 오버레이 갱신 (CSS 줌과 분리되어 선명)
         */
        updateUiOverlay: function (previewRect) {
            var self = this;
            if (!self.$uiLayer || !self.$uiLayer.length) return;

            self.$uiLayer.empty();

            if (previewRect && previewRect.w > 0 && previewRect.h > 0) {
                self.$uiLayer.append(self.buildGuideEl(previewRect));
            }

            if (self.selectedIndex >= 0 && self.regions[self.selectedIndex]) {
                var r = self.regions[self.selectedIndex];
                self.$uiLayer.append(self.buildSelectionEl(r));
                self.$uiLayer.append(self.buildTrashEl(r));
            }
        },

        buildGuideEl: function (r) {
            var self = this;
            var p1 = self.toViewPos(r.x, r.y);
            var p2 = self.toViewPos(r.x + r.w, r.y + r.h);
            var left = Math.min(p1.x, p2.x);
            var top = Math.min(p1.y, p2.y);
            var w = Math.abs(p2.x - p1.x);
            var h = Math.abs(p2.y - p1.y);
            return $('<div class="masking-ui-guide"></div>').css({
                position: 'absolute',
                left: left + 'px',
                top: top + 'px',
                width: w + 'px',
                height: h + 'px',
                boxSizing: 'border-box',
                border: '2px dashed #ff2d2d',
                pointerEvents: 'none'
            });
        },

        buildSelectionEl: function (r) {
            var self = this;
            var p1 = self.toViewPos(r.x, r.y);
            var p2 = self.toViewPos(r.x + r.w, r.y + r.h);
            var left = Math.min(p1.x, p2.x);
            var top = Math.min(p1.y, p2.y);
            var w = Math.abs(p2.x - p1.x);
            var h = Math.abs(p2.y - p1.y);
            var hs = 8; // 퍼블: 작은 흰 사각 핸들

            var $box = $('<div class="masking-ui-selection"></div>').css({
                position: 'absolute',
                left: left + 'px',
                top: top + 'px',
                width: w + 'px',
                height: h + 'px',
                boxSizing: 'border-box',
                border: '1.5px solid #2b6cff',
                pointerEvents: 'none'
            });

            var points = {
                nw: { x: 0, y: 0 },
                n: { x: w / 2, y: 0 },
                ne: { x: w, y: 0 },
                e: { x: w, y: h / 2 },
                se: { x: w, y: h },
                s: { x: w / 2, y: h },
                sw: { x: 0, y: h },
                w: { x: 0, y: h / 2 }
            };

            for (var i = 0; i < HANDLES.length; i++) {
                var key = HANDLES[i];
                var p = points[key];
                $('<div class="masking-ui-handle"></div>').css({
                    position: 'absolute',
                    left: (p.x - hs / 2) + 'px',
                    top: (p.y - hs / 2) + 'px',
                    width: hs + 'px',
                    height: hs + 'px',
                    boxSizing: 'border-box',
                    background: '#fff',
                    border: '1px solid #2b6cff',
                    pointerEvents: 'none'
                }).appendTo($box);
            }

            return $box;
        },

        buildTrashEl: function (r) {
            var self = this;
            // 퍼블: 선택 박스 옆 흰 사각 버튼. 화면 밖으로 나가면 영역 안쪽으로 배치
            var TRASH_SIZE = 28;
            var TRASH_GAP = 4;
            var p1 = self.toViewPos(r.x, r.y);
            var p2 = self.toViewPos(r.x + r.w, r.y + r.h);
            var selLeft = Math.min(p1.x, p2.x);
            var selTop = Math.min(p1.y, p2.y);
            var selRight = Math.max(p1.x, p2.x);
            var vw = self.$viewport && self.$viewport.length ? self.$viewport.width() : Infinity;
            var vh = self.$viewport && self.$viewport.length ? self.$viewport.height() : Infinity;

            // 1) 우측 바깥 → 2) 좌측 바깥 → 3) 선택 영역 안(우상단)
            var left = selRight + 2;
            var top = selTop;

            if (left + TRASH_SIZE > vw) {
                left = selLeft - 2 - TRASH_SIZE;
            }
            if (left < 0 || left + TRASH_SIZE > vw) {
                left = selRight - TRASH_SIZE - TRASH_GAP;
                if (left < selLeft) {
                    left = selLeft + TRASH_GAP;
                }
                top = selTop + TRASH_GAP;
            }
            if (top + TRASH_SIZE > vh) {
                top = Math.max(0, vh - TRASH_SIZE);
            }
            if (top < 0) top = 0;

            left = Math.max(0, Math.min(left, Math.max(0, vw - TRASH_SIZE)));
            top = Math.max(0, Math.min(top, Math.max(0, vh - TRASH_SIZE)));

            var $el = $('<div class="masking-ui-trash" role="button" title="삭제"></div>').css({
                position: 'absolute',
                left: left + 'px',
                top: top + 'px',
                width: TRASH_SIZE + 'px',
                height: TRASH_SIZE + 'px',
                borderRadius: '4px',
                backgroundColor: '#fff',
                border: '1px solid #d0d5dd',
                boxShadow: '0 1px 2px rgba(16, 24, 40, 0.08)',
                boxSizing: 'border-box',
                // 캔버스 밖(뷰포트)에 있어도 클릭 가능하도록
                pointerEvents: 'auto',
                cursor: 'pointer',
                zIndex: 2,
                backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'%23667085\' stroke-width=\'1.8\' stroke-linecap=\'round\' stroke-linejoin=\'round\'%3E%3Cpolyline points=\'3 6 5 6 21 6\'/%3E%3Cpath d=\'M8 6V4h8v2\'/%3E%3Cpath d=\'M19 6l-1 14H6L5 6\'/%3E%3Cline x1=\'10\' y1=\'11\' x2=\'10\' y2=\'17\'/%3E%3Cline x1=\'14\' y1=\'11\' x2=\'14\' y2=\'17\'/%3E%3C/svg%3E")',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: '20px 20px'
            });

            $el.on('mousedown touchstart', function (e) {
                e.preventDefault();
                e.stopPropagation();
                self.deleteSelectedRegion();
            });

            return $el;
        },

        getViewScale: function () {
            var self = this;
            var base = self.baseFit;
            if (!base || !isFinite(base) || base <= 0) {
                if (self.canvas && self.canvas.style.width) {
                    base = parseFloat(self.canvas.style.width) / self.canvas.width;
                } else {
                    base = 1;
                }
            }
            var zoom = self.scale && isFinite(self.scale) ? self.scale : 1;
            var vs = base * zoom;
            return vs > 0 ? vs : 1;
        },

        getUiLength: function (screenPx) {
            return screenPx / this.getViewScale();
        },

        getHandleSize: function () {
            return this.getUiLength(8);
        },

        getTrashSize: function () {
            return this.getUiLength(28);
        },

        getTrashRect: function (r) {
            var self = this;
            // buildTrashEl과 동일한 우선순위 (자연좌표, 캔버스 hit-test용)
            var size = self.getUiLength(28);
            var gap = self.getUiLength(4);
            var x = r.x + r.w + self.getUiLength(2);
            var y = r.y;

            if (x + size > self.canvas.width) {
                x = r.x - size - self.getUiLength(2);
            }
            if (x < 0 || x + size > self.canvas.width) {
                x = r.x + r.w - size - gap;
                if (x < r.x) x = r.x + gap;
                y = r.y + gap;
            }
            if (y + size > self.canvas.height) {
                y = Math.max(0, self.canvas.height - size);
            }
            if (y < 0) y = 0;

            x = Math.max(0, Math.min(x, self.canvas.width - size));
            y = Math.max(0, Math.min(y, self.canvas.height - size));

            return { x: x, y: y, w: size, h: size };
        },

        hitTestTrash: function (r, pt) {
            var self = this;
            if (!r) return false;
            var tr = self.getTrashRect(r);
            return pt.x >= tr.x && pt.x <= tr.x + tr.w && pt.y >= tr.y && pt.y <= tr.y + tr.h;
        },

        getHandlePoints: function (r) {
            return {
                nw: { x: r.x, y: r.y },
                n: { x: r.x + r.w / 2, y: r.y },
                ne: { x: r.x + r.w, y: r.y },
                e: { x: r.x + r.w, y: r.y + r.h / 2 },
                se: { x: r.x + r.w, y: r.y + r.h },
                s: { x: r.x + r.w / 2, y: r.y + r.h },
                sw: { x: r.x, y: r.y + r.h },
                w: { x: r.x, y: r.y + r.h / 2 }
            };
        },

        hitTestHandle: function (r, pt) {
            var self = this;
            if (!r) return null;
            var hs = self.getUiLength(14);
            var points = self.getHandlePoints(r);
            for (var i = 0; i < HANDLES.length; i++) {
                var key = HANDLES[i];
                var p = points[key];
                if (Math.abs(pt.x - p.x) <= hs && Math.abs(pt.y - p.y) <= hs) {
                    return key;
                }
            }
            return null;
        },

        hitTestRegion: function (pt) {
            var self = this;
            for (var i = self.regions.length - 1; i >= 0; i--) {
                var r = self.regions[i];
                if (pt.x >= r.x && pt.x <= r.x + r.w && pt.y >= r.y && pt.y <= r.y + r.h) {
                    return i;
                }
            }
            return -1;
        },

        clampRegion: function (r) {
            var self = this;
            var maxW = self.canvas.width;
            var maxH = self.canvas.height;
            var nr = {
                x: r.x,
                y: r.y,
                w: r.w,
                h: r.h,
                mode: r.mode || self.mode
            };
            if (nr.w < 3) nr.w = 3;
            if (nr.h < 3) nr.h = 3;
            if (nr.x < 0) nr.x = 0;
            if (nr.y < 0) nr.y = 0;
            if (nr.x + nr.w > maxW) nr.x = maxW - nr.w;
            if (nr.y + nr.h > maxH) nr.y = maxH - nr.h;
            if (nr.x < 0) {
                nr.w += nr.x;
                nr.x = 0;
            }
            if (nr.y < 0) {
                nr.h += nr.y;
                nr.y = 0;
            }
            if (nr.w < 3) nr.w = 3;
            if (nr.h < 3) nr.h = 3;
            return nr;
        },

        resizeRegion: function (startRect, handle, pt) {
            var r = {
                x: startRect.x,
                y: startRect.y,
                w: startRect.w,
                h: startRect.h,
                mode: startRect.mode
            };
            var right = startRect.x + startRect.w;
            var bottom = startRect.y + startRect.h;

            if (handle.indexOf('w') > -1) {
                r.x = Math.min(pt.x, right - 3);
                r.w = right - r.x;
            }
            if (handle.indexOf('e') > -1) {
                r.w = Math.max(3, pt.x - startRect.x);
            }
            if (handle.indexOf('n') > -1) {
                r.y = Math.min(pt.y, bottom - 3);
                r.h = bottom - r.y;
            }
            if (handle.indexOf('s') > -1) {
                r.h = Math.max(3, pt.y - startRect.y);
            }
            return this.clampRegion(r);
        },

        cursorForHandle: function (handle) {
            var map = {
                nw: 'nwse-resize',
                se: 'nwse-resize',
                ne: 'nesw-resize',
                sw: 'nesw-resize',
                n: 'ns-resize',
                s: 'ns-resize',
                e: 'ew-resize',
                w: 'ew-resize'
            };
            return map[handle] || 'crosshair';
        },

        setCursor: function (cursor) {
            if (this.canvas) this.canvas.style.cursor = cursor;
        },

        applyViewTransform: function () {
            var self = this;
            if (!self.canvas) return;
            self.canvas.style.transform =
                'translate(' + self.offsetX + 'px,' + self.offsetY + 'px) scale(' + self.scale + ')';
        },

        toNatural: function (clientX, clientY) {
            var self = this;
            var r = self.canvas.getBoundingClientRect();
            return {
                x: (clientX - r.left) * (self.canvas.width / r.width),
                y: (clientY - r.top) * (self.canvas.height / r.height)
            };
        },

        norm: function (a, b) {
            return {
                x: Math.min(a.x, b.x),
                y: Math.min(a.y, b.y),
                w: Math.abs(a.x - b.x),
                h: Math.abs(a.y - b.y)
            };
        },

        bindPointer: function () {
            var self = this;
            if (!self.canvas) return;

            self.canvas.onmousedown = function (e) {
                if (!self.origImg) return;
                e.preventDefault();
                self.onPointerDown(e.clientX, e.clientY, e);
            };

            self.canvas.onmousemove = function (e) {
                if (!self.origImg) return;
                // 드래그 중에는 window mousemove에서 처리 (캔버스 밖으로 나가도 유지)
                if (self.interaction) return;
                self.onPointerMove(e.clientX, e.clientY, e);
            };

            self.canvas.onwheel = function (e) {
                if (!self.origImg) return;
                e.preventDefault();
                var delta = e.deltaY > 0 ? 0.9 : 1.1;
                self.zoomAt(e.clientX, e.clientY, delta);
            };

            self.canvas.ontouchstart = function (e) {
                if (!self.origImg) return;
                e.preventDefault();
                // 모바일: canvas touch는 click이 안 떠서 여기서 안내 배너 닫기
                self.hideNoti();
                if (e.touches.length === 2) {
                    self.interaction = null;
                    var vr = self.$viewport && self.$viewport[0]
                        ? self.$viewport[0].getBoundingClientRect()
                        : { left: 0, top: 0 };
                    var cx = (e.touches[0].clientX + e.touches[1].clientX) / 2;
                    var cy = (e.touches[0].clientY + e.touches[1].clientY) / 2;
                    self.pinch = {
                        dist: self.touchDistance(e.touches),
                        scale: self.scale,
                        // offset은 뷰포트 로컬 좌표 → 중점도 로컬로 저장
                        startLx: cx - vr.left,
                        startLy: cy - vr.top,
                        ox: self.offsetX,
                        oy: self.offsetY
                    };
                    return;
                }
                if (e.touches.length === 1) {
                    self.pinch = null;
                    self.onPointerDown(e.touches[0].clientX, e.touches[0].clientY, null);
                }
            };

            self.canvas.ontouchmove = function (e) {
                if (!self.origImg) return;
                e.preventDefault();
                if (e.touches.length === 2 && self.pinch) {
                    var dist = self.touchDistance(e.touches);
                    var nextScale = Math.min(MAX_SCALE, Math.max(MIN_SCALE, self.pinch.scale * (dist / self.pinch.dist)));
                    var vr = self.$viewport && self.$viewport[0]
                        ? self.$viewport[0].getBoundingClientRect()
                        : { left: 0, top: 0 };
                    var cx = (e.touches[0].clientX + e.touches[1].clientX) / 2;
                    var cy = (e.touches[0].clientY + e.touches[1].clientY) / 2;
                    var lx = cx - vr.left;
                    var ly = cy - vr.top;

                    // 1) 시작 대비 중점 이동만큼 팬
                    var offsetX = self.pinch.ox + (lx - self.pinch.startLx);
                    var offsetY = self.pinch.oy + (ly - self.pinch.startLy);
                    // 2) 현재 중점 기준으로 스케일 (client 좌표와 offset 좌표계 혼용 금지)
                    var scaleRatio = nextScale / self.pinch.scale;
                    self.offsetX = lx - (lx - offsetX) * scaleRatio;
                    self.offsetY = ly - (ly - offsetY) * scaleRatio;
                    self.scale = nextScale;
                    self.applyViewTransform();
                    self.render();
                    return;
                }
                if (e.touches.length === 1) {
                    self.onPointerMove(e.touches[0].clientX, e.touches[0].clientY, null);
                }
            };

            self.canvas.ontouchend = function (e) {
                if (e.touches.length < 2) self.pinch = null;
                if (e.touches.length === 0) {
                    self.onPointerUp(e.changedTouches[0].clientX, e.changedTouches[0].clientY);
                }
            };

            if (!self._windowBound) {
                self._windowBound = true;
                window.addEventListener('mousemove', function (e) {
                    if (!self.interaction || !self.canvas) return;
                    self.onPointerMove(e.clientX, e.clientY, e);
                });
                window.addEventListener('mouseup', function (e) {
                    if (!self.interaction || !self.canvas) return;
                    self.onPointerUp(e.clientX, e.clientY);
                });
                // 포커스 잃을 때 Space 상태 초기화
                window.addEventListener('blur', function () {
                    self.spacePressed = false;
                });
            }
        },

        touchDistance: function (touches) {
            var dx = touches[0].clientX - touches[1].clientX;
            var dy = touches[0].clientY - touches[1].clientY;
            return Math.sqrt(dx * dx + dy * dy);
        },

        zoomAt: function (clientX, clientY, factor) {
            var self = this;
            if (!self.canvas) return;

            var next = Math.min(MAX_SCALE, Math.max(MIN_SCALE, self.scale * factor));
            if (next === self.scale) return;

            // offset은 뷰포트 로컬 좌표이므로 커서도 뷰포트 기준으로 변환
            var vr = self.$viewport && self.$viewport[0]
                ? self.$viewport[0].getBoundingClientRect()
                : { left: 0, top: 0 };
            var lx = clientX - vr.left;
            var ly = clientY - vr.top;

            var contentX = (lx - self.offsetX) / self.scale;
            var contentY = (ly - self.offsetY) / self.scale;

            self.scale = next;
            self.offsetX = lx - contentX * next;
            self.offsetY = ly - contentY * next;
            self.applyViewTransform();
            self.render();
        },

        /** 이미지 팬(이동) 시작 여부: Space + 드래그 */
        shouldPan: function (e) {
            return !!this.spacePressed;
        },

        startPan: function (clientX, clientY) {
            var self = this;
            self.interaction = {
                type: 'pan',
                startClientX: clientX,
                startClientY: clientY,
                startOffsetX: self.offsetX,
                startOffsetY: self.offsetY
            };
            self.setCursor('grabbing');
        },

        onPointerDown: function (clientX, clientY, e) {
            var self = this;

            // 이미지(캔버스) 조작 시작 시 안내 배너 닫기
            self.hideNoti();

            // 마스킹 생성과 분리: Space → 이미지 이동
            if (self.shouldPan(e)) {
                self.startPan(clientX, clientY);
                return;
            }

            var pt = self.toNatural(clientX, clientY);
            var selected = self.selectedIndex >= 0 ? self.regions[self.selectedIndex] : null;

            if (selected && self.hitTestTrash(selected, pt)) {
                self.deleteSelectedRegion();
                return;
            }

            var handle = self.hitTestHandle(selected, pt);
            if (handle) {
                self.pushUndo();
                self.interaction = {
                    type: 'resize',
                    handle: handle,
                    startPt: pt,
                    startRect: $.extend({}, selected)
                };
                self.setCursor(self.cursorForHandle(handle));
                return;
            }

            var hitIndex = self.hitTestRegion(pt);
            if (hitIndex >= 0) {
                self.selectedIndex = hitIndex;
                self.pushUndo();
                self.interaction = {
                    type: 'move',
                    startPt: pt,
                    startRect: $.extend({}, self.regions[hitIndex])
                };
                self.setCursor('move');
                self.render();
                return;
            }

            self.selectedIndex = -1;
            self.interaction = {
                type: 'draw',
                startPt: pt
            };
            self.setCursor('crosshair');
            self.render();
        },

        onPointerMove: function (clientX, clientY, e) {
            var self = this;
            var pt = self.toNatural(clientX, clientY);

            if (!self.interaction) {
                if (self.spacePressed) {
                    self.setCursor('grab');
                    return;
                }
                var selected = self.selectedIndex >= 0 ? self.regions[self.selectedIndex] : null;
                if (selected && self.hitTestTrash(selected, pt)) {
                    self.setCursor('pointer');
                } else {
                    var handle = self.hitTestHandle(selected, pt);
                    if (handle) {
                        self.setCursor(self.cursorForHandle(handle));
                    } else if (self.hitTestRegion(pt) >= 0) {
                        self.setCursor('move');
                    } else {
                        self.setCursor('crosshair');
                    }
                }
                return;
            }

            if (self.interaction.type === 'pan') {
                self.offsetX = self.interaction.startOffsetX + (clientX - self.interaction.startClientX);
                self.offsetY = self.interaction.startOffsetY + (clientY - self.interaction.startClientY);
                self.applyViewTransform();
                self.render();
                self.setCursor('grabbing');
                return;
            }

            if (self.interaction.type === 'draw') {
                self.render(self.norm(self.interaction.startPt, pt));
                return;
            }

            if (self.interaction.type === 'move') {
                var dx = pt.x - self.interaction.startPt.x;
                var dy = pt.y - self.interaction.startPt.y;
                self.regions[self.selectedIndex] = self.clampRegion({
                    x: self.interaction.startRect.x + dx,
                    y: self.interaction.startRect.y + dy,
                    w: self.interaction.startRect.w,
                    h: self.interaction.startRect.h,
                    mode: self.interaction.startRect.mode
                });
                self.dirty = true;
                self.rebuildCommitted();
                self.render();
                return;
            }

            if (self.interaction.type === 'resize') {
                self.regions[self.selectedIndex] = self.resizeRegion(
                    self.interaction.startRect,
                    self.interaction.handle,
                    pt
                );
                self.dirty = true;
                self.rebuildCommitted();
                self.render();
            }
        },

        onPointerUp: function (clientX, clientY) {
            var self = this;
            if (!self.interaction || !self.canvas) return;

            var pt = self.toNatural(clientX, clientY);
            var interaction = self.interaction;
            self.interaction = null;

            if (interaction.type === 'pan') {
                self.setCursor(self.spacePressed ? 'grab' : (self.selectedIndex >= 0 ? 'move' : 'crosshair'));
                self.render();
                return;
            }

            if (interaction.type === 'draw') {
                var r = self.norm(interaction.startPt, pt);
                if (r.w < 3 || r.h < 3) {
                    self.render();
                    self.setCursor('crosshair');
                    return;
                }
                self.pushUndo();
                r = self.clampRegion({
                    x: r.x,
                    y: r.y,
                    w: r.w,
                    h: r.h,
                    mode: self.mode
                });
                self.regions.push(r);
                self.selectedIndex = self.regions.length - 1;
                self.dirty = true;
                self.rebuildCommitted();
                self.render();
                self.setCursor('move');
                return;
            }

            self.rebuildCommitted();
            self.render();
            self.setCursor(self.selectedIndex >= 0 ? 'move' : 'crosshair');
        },

        pushUndo: function () {
            var self = this;
            self.undoStack.push({
                regions: JSON.parse(JSON.stringify(self.regions)),
                selectedIndex: self.selectedIndex
            });
            if (self.undoStack.length > 20) self.undoStack.shift();
            self.setUndoEnabled(true);
        },

        undo: function () {
            var self = this;
            var s = self.undoStack.pop();
            if (!s) return;
            self.regions = s.regions || [];
            self.selectedIndex = typeof s.selectedIndex === 'number' ? s.selectedIndex : -1;
            if (self.selectedIndex >= self.regions.length) {
                self.selectedIndex = self.regions.length - 1;
            }
            self.dirty = self.regions.length > 0 || self.undoStack.length > 0;
            self.rebuildCommitted();
            self.render();
            self.setUndoEnabled(self.undoStack.length > 0);
        },

        applyMask: function (r) {
            var self = this;
            r = {
                x: Math.round(r.x),
                y: Math.round(r.y),
                w: Math.round(r.w),
                h: Math.round(r.h),
                mode: r.mode || self.mode
            };
            if (r.w < 1 || r.h < 1) return;
            self.cctx.fillStyle = '#000';
            self.cctx.fillRect(r.x, r.y, r.w, r.h);
        },

        attach: function () {
            var self = this;
            if (!self.committed || self.$attachBtn.prop('disabled')) return;

            self.selectedIndex = -1;
            self.rebuildCommitted();
            self.render();

            var mime = /\.jpe?g$/i.test(self.curName) ? 'image/jpeg' : 'image/png';
            var outName = self.curName.replace(/\.[^.]+$/, '') + '_masked' + (mime === 'image/jpeg' ? '.jpg' : '.png');

            var finish = function (blob) {
                if (!blob) {
                    self.openCheck(self.$check5);
                    return;
                }
                var maskedFile;
                try {
                    maskedFile = new File([blob], outName, { type: mime });
                } catch (err) {
                    maskedFile = blob;
                    maskedFile.name = outName;
                }

                self.forceClose = true;
                self.dirty = false;
                if (self.onAttach) {
                    try {
                        self.onAttach(maskedFile);
                    } catch (e) {
                        self.forceClose = false;
                        self.openCheck(self.$check5);
                        return;
                    }
                }
                if (self.$popup.vcModal) self.$popup.vcModal('hide');
                self.resetEditor();
                self.forceClose = false;
            };

            if (self.committed.toBlob) {
                self.committed.toBlob(finish, mime, 0.92);
            } else {
                try {
                    var dataUrl = self.committed.toDataURL(mime, 0.92);
                    var arr = dataUrl.split(',');
                    var bstr = atob(arr[1]);
                    var u8 = new Uint8Array(bstr.length);
                    for (var i = 0; i < bstr.length; i++) u8[i] = bstr.charCodeAt(i);
                    finish(new Blob([u8], { type: mime }));
                } catch (e) {
                    self.openCheck(self.$check5);
                }
            }
        }
    };

    window.imgMaskEditor = imgMaskEditor;

    $(document).ready(function () {
        if ($('#popup-masking-1').length) {
            imgMaskEditor.init();
        }
    });

})();
